import type {DirectoryItem, FileTreePayload} from '@github-ui/code-view-types'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

type FileTreeResponse = {
  payload: {
    fileTree: FileTreePayload
  }
}

export type NormalizedTreePayload = {
  tree: {
    items: DirectoryItem[]
    totalCount: number
  }
}

export async function fetchTree({
  owner,
  repo,
  branch,
  path,
}: {
  owner: string
  repo: string
  branch: string
  path: string
}) {
  const response = await verifiedFetchJSON(`/${owner}/${repo}/_file_tree`, {
    method: 'POST',
    body: {
      branch,
      start: path,
      stop: path,
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch tree data: ${response.status} ${response.statusText}`)
  }

  const data: FileTreeResponse = await response.json()
  const tree = data.payload?.fileTree?.fileTree?.[path]

  if (!tree) {
    throw new Error(`Unable to find file tree data for path: ${path}`)
  }

  return {tree}
}
